import dayjs from "dayjs";
export default function formatDate(date, showTime = false) {
    const format = showTime ? "M/D/YYYY (h:mmA)" : "M/D/YYYY";
    return dayjs(date).format(format);
}
//# sourceMappingURL=formatDate.js.map